// this export is not a function but rather an object
export default {
  header: "My Pizza Page",
  view: "Pizza",
  pizzas: []
};
